module.exports = __webpack_public_path__ + "img/Premium Icon blue.34c286ca.svg";